import { useRouter } from 'next/router';
import { useMemo } from 'react';

export function useLandingLocalePrefix(): string {
  const { locale } = useRouter();

  if (!locale || locale === 'default') {
    return '/en';
  }

  return `/${locale}`;
}

/** Resolve #section on home; `/{locale}/#section` on other landing routes. Must be called once per component. */
export function useMainLandingSectionHrefFactory(): (sectionId: string) => string {
  const { pathname } = useRouter();
  const prefix = useLandingLocalePrefix();

  return useMemo(
    () => (sectionId: string) => (pathname === '/' ? `#${sectionId}` : `${prefix}/#${sectionId}`),
    [pathname, prefix]
  );
}
